import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    produzionetrattamenti: [],
    singleProduzioneTrattamenti: null,
    siccurezza: [],
    appicazione: [],
    trattamento: [],
    isLoading: false,
    error: null,
};
const produzioneTrattamentiSlice = createSlice({
    name: "produzionetrattamenti",
    initialState,
    reducers: {
        setTrattamenti: (state, action) => {
            state.produzionetrattamenti = action.payload;
        },
        addTrattamenti: (state, action) => {
            state.produzionetrattamenti.push(action.payload);
        },
        addSiccurezza: (state, action) => {
            state.siccurezza = action.payload
        },
        addAppicazione: (state, action) => {
            state.appicazione = action.payload
        },
        addTrattamento: (state, action) => {
            state.trattamento = action.payload
        },
        setSingleTrattamenti: (state, action) => {
            // console.log("Updating Redux state with sensor data:", action.payload); // :white_check_mark: Check Redux update
            state.singleProduzioneTrattamenti = action.payload;
        },
        updateTrattamenti: (state, action) => {
            const index = state.produzionetrattamenti.findIndex(
                (item) => item.id === action.payload.id
            );
            if (index !== -1) {
                state.produzionetrattamenti[index] = action.payload;
            }
        },
        deleteTrattamenti: (state, action) => {
            state.produzionetrattamenti = state.produzionetrattamenti.filter(
                (item) => item.id !== action.payload
            );
        },
        apiRequestStart: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        apiRequestSuccess: (state) => {
            state.isLoading = false;
        },
        apiRequestFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});
export const {
    setTrattamenti,
    addTrattamenti,
    setSingleTrattamenti,
    updateTrattamenti,
    deleteTrattamenti,
    apiRequestStart,
    apiRequestSuccess,
    apiRequestFailure,
    getCultura,
    getVarieta,
    getCertificazioni,
    addSiccurezza,
    addAppicazione,
    addTrattamento
} = produzioneTrattamentiSlice.actions;
export const selectTrattamenti = (state) => state.produzionetrattamenti?.produzionetrattamenti;
export const selectSingleTrattamenti = (state) => state.produzionetrattamenti?.singleProduzioneTrattamenti
export const selectIsLoading = (state) => state.produzionetrattamenti?.isLoading;
export const selectError = (state) => state.produzionetrattamenti?.error;
export default produzioneTrattamentiSlice.reducer;